import container from "@/lib/di/container";
import { Suspense, useEffect, useState } from "react";
import { DetailModal } from "./modals/DetailModal";
import { Button, message, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { formatDateTimePipe } from "@/core/pipes/format-date.pipe";
import { WaterSupplySuspensionLevelModel, WaterSupplySuspensionLevelModelFactory } from "@/core/models/water-supply-suspension-level.model";
import { WaterSupplySuspensionLevelRepo } from "@/core/repos/tables/water-supply-suspension-level.repo";
import { WaterSupplySuspensionRepo } from "@/core/repos/tables/water-supply-suspension.repo";
import { WaterSupplySuspensionModel } from "@/core/models/water-supply-suspension.model";
import { useUpdate } from "@/core/hooks/use-update.hook";
import { useTitleDataStore } from "@/core/stores/title-data.store";
import { useSearchParams } from "react-router";
import { FilterInputTemplate, FilterBar } from "@/app/home/components/filter/FilterBar";
import { FilterSearchPayload, DataTable } from "@/app/home/components/table/DataTable";
import { DeleteButton } from "@/app/home/components/table/DeleteButton";

const waterSupplySuspensionLevelRepo = container.get(WaterSupplySuspensionLevelRepo);
const waterSupplySuspensionRepo = container.get(WaterSupplySuspensionRepo);

function WaterSuspensionLevel() {
    const titleData = useTitleDataStore();
    const [searchParams] = useSearchParams();
    const waterSupplySuspensionId = searchParams.get('id');
    const [modalData, setModalData] = useState<WaterSupplySuspensionLevelModel>(WaterSupplySuspensionLevelModelFactory.getEmpty())
    const [filterMap, setFilterMap] = useState<Map<string, FilterSearchPayload>>(new Map(
        Object.entries({"waterSupplySuspensionId": {key: "waterSupplySuspensionId", value: waterSupplySuspensionId??""}})))
    const [selectedRows, setSelectedRows] = useState<WaterSupplySuspensionLevelModel[]>([]);
    const [isDetailModal, setDetailModal] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [filterTemplates] = useState<FilterInputTemplate[]>([
        // {
        //     dataIndex: "search",
        //     label: "Tìm kiếm",
        //     placeholder: "Nhập nội dung tìm kiếm",
        //     type: FilterInputType.text,
        // },
    ])

    const [waterSupplySuspension, setWaterSupplySuspension] = useState<WaterSupplySuspensionModel>()

    const showDetail = (record: WaterSupplySuspensionLevelModel) => {
        console.log(record);
        setModalData(record);
        setDetailModal(true);
    };

    const init = async () => {
        if (waterSupplySuspensionId) {
            titleData.setTitleActions({
                text: "Tạo Vùng ngưng cấp nước",
                onPress: () => {
                    showDetail(WaterSupplySuspensionLevelModelFactory.getEmpty(waterSupplySuspensionId))
                }
            })
            titleData.setTitleBack(true);
            const suspension = await waterSupplySuspensionRepo.detail(waterSupplySuspensionId);
            if (suspension) {
                setWaterSupplySuspension(suspension);
            }
        }
    }

    useUpdate(()=>{
        if (waterSupplySuspension?.name) {
            titleData.setTitleText(waterSupplySuspension?.name);
        }
    }, [waterSupplySuspension])

    useEffect(()=>{init()}, []);

    const deleteSelected = async () => {
        setDeleting(true);
        const result = await waterSupplySuspensionLevelRepo.deleteMany(selectedRows);
        messageApi.success({
            content: `Bạn đã xoá thành công ${result.success}/${result.total} bản ghi`
        })
        setDeleting(false);
    }


    async function onFilterChange(map: Map<string, FilterSearchPayload>) {
        setFilterMap(new Map(map));
    }

    function onRowSelect(rows: WaterSupplySuspensionLevelModel[]) {
        setSelectedRows([...rows]);
    }

    return (
    <div className="px-4 py-2">
        {contextHolder}
        <FilterBar setMap={setFilterMap} onChange={onFilterChange} templates={filterTemplates} map={filterMap} actions={[
            <div key={1} className="mt-6">
                <DeleteButton loading={deleting} length={selectedRows.length} onConfirm={deleteSelected} noGap/>
            </div>
        ]}/>
        <div className="mt-4 border-t border-dashed border-gray-300 pt-6">
            <DataTable<WaterSupplySuspensionLevelModel>
                columns={[
                    { dataIndex: 'provinceName', name: 'Tỉnh/TP' },
                    { dataIndex: 'districtName', name: 'Quận/Huyện' },
                    { dataIndex: 'wardName', name: 'Xã' },
                    { dataIndex: 'tollAreaName', name: 'Khu vực' },
                    { dataIndex: 'startTime', name: 'Thời gian bắt đầu ngưng', pipe: formatDateTimePipe},
                    { dataIndex: 'endTime', name: 'Thời gian cấp nước trở lại', pipe: formatDateTimePipe },
                    {
                        name: 'Thao tác',
                        render: (_, record) => (
                            <div className="flex flex-row px-1 items-center justify-center">
                                <Tooltip title="Sửa"><Button type="text" icon={<InfoCircleOutlined />} onClick={() => showDetail(record)}/></Tooltip>
                            </div>
                        ),
                        fixed: "right",
                    },
                ]}
                repository={waterSupplySuspensionLevelRepo}
                filterMap={filterMap}
                onSelect={onRowSelect}
            ></DataTable>
        </div>
        <DetailModal isModalOpen={isDetailModal} setIsModalOpen={setDetailModal} data={modalData}></DetailModal>
    </div>)
}

export default function WaterSuspensionLevelPage() {
    return <Suspense>
        <WaterSuspensionLevel />
    </Suspense>
}